<template lang="pug">
textarea.text-area-study(
  :style='setStyle',
  @input='updateValue',
  :value='value',
  :placeholder='placeholder',
  ref='textarea'
)
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref, Watch } from 'vue-property-decorator'

/**
 * 学習用テキストエリア
 * 入力値に応じて高さがリサイズされる
 */
@Component
export default class TextAreaStudy extends Vue {
  private resizeHeight = 0

  // 入力値
  @Prop()
  value!: string

  // プレースホルダー（任意）
  @Prop()
  placeholder?: string

  // テキストエリアref
  @Ref() textarea!: HTMLElement

  get setStyle(): { [key: string]: string } {
    return {
      '--textarea-height': `${this.resizeHeight}px`,
    }
  }

  private updateValue(event: Event): void {
    this.$emit('input', (event.target as HTMLInputElement).value)
  }

  private resize() {
    this.resizeHeight = 0
    this.$nextTick(() => {
      this.resizeHeight = this.textarea.scrollHeight
    })
  }

  private mounted() {
    this.resize()
  }

  @Watch('value')
  private onValueInput() {
    this.resize()
  }
}
</script>

<style lang="stylus" scoped>
.text-area-study
  resize none
  width 100%
  height var(--textarea-height)
  min-height 100px
  border-radius 4px
  padding 4px
</style>
